<template>
  <div class="d-flex flex-column">
    <span :class="`text-${text}`" class="text-xl font-weight-bold">
      Postleitzahl:
    </span>
    <div class="d-flex">
      <autocomplete
        v-model="postcode"
        url="/api/v1/register/validate-step/1/autocomplete"
        requestType="get"
        property="location"
        :threshold="2"
      ></autocomplete>
      <SquareButton @click.native="select">-></SquareButton>
    </div>
    <div v-if="error" class="row">
      <div class="col-12">
        <div class="alert alert-danger" role="alert">
          <span>{{ error }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.autocomplete input {
  height: 60px;
  border-radius: 10px;
  border: 1px solid black;

  padding: 8px;

  margin-right: 8px;
}
</style>

<script>
import SquareButton from "./SquareButton.vue";
import Autocomplete from "autocomplete-vue";

export default {
  props: {
    text: {
      type: String,
      default: "white"
    }
  },
  components: {
    SquareButton,
    Autocomplete
  },
  data() {
    return {
      error: "",
      postcode: "",
      itemStore: []
    };
  },
  methods: {
    getLabel(entry) {
      return entry ? entry.name : "";
    },
    updateItems(text) {
      this.itemStore = this.meta.filter(entry =>
        entry.zipcode.startsWith(text)
      );
    },
    mapCountryToCode(country) {
      if (country === "DE") {
        return 0;
      } else if (country === "CH") {
        return 1;
      } else {
        return 2;
      }
    },
    validateZipCode() {
      return this.$http
        .post(`/api/v1/register/validate-step/1/completeZip`, {
          zipcode: this.postcode
        })
        .then(({ data }) => {
          this.postcode = data;
        })
        .catch(error => {
          this.error = error.response.data.message;
        });
    },
    async select() {
      if (!this.postcode.includes("(")) {
        await this.validateZipCode();
      }
      if (this.postcode.includes("(")) {
        let countryAndCity = this.postcode.split("(")[1];

        let country = countryAndCity
          ? this.mapCountryToCode(
              countryAndCity.substring(0, countryAndCity.indexOf(","))
            )
          : null;

        this.$emit("input", {
          zipcode: this.postcode.split(" ")[0],
          country_iso3166: country
        });
      }
    }
  }
};
</script>
